import Swiper from 'swiper';
import { Autoplay } from 'swiper';
import { getDisplayMode } from '../common/libs.js';

const setMovieSlider = () => {
  const targetSliders = document.querySelectorAll('.js-movie-slider');

  targetSliders.forEach((Slider) => {
    const slideLength = Slider?.querySelectorAll(".swiper-slide").length;
    let first = false;
    let windowWidth = Slider?.clientWidth;
    let slideSize = 0;
    let slideSpace = 0;
    if (getDisplayMode() == 1) {
      slideSize = 594;
      slideSpace = 10;
    } else {
      slideSize = 329;
      slideSpace = 10;
    }
    let viewSlideLength = Math.floor(windowWidth / (slideSize + slideSpace));

    let shouldInit = false;
    if (getDisplayMode() == 1) {
      shouldInit = slideLength > viewSlideLength;
    } else {
      shouldInit = slideLength > 1;
    }


    if (shouldInit)  {
      var swiper = new Swiper(Slider, {
        modules: [Autoplay],
        autoplay: {
          disableOnInteraction: false,
          delay: 0,
        },
        speed: 15000,
        loop: true,
        slidesPerView: 'auto',
      });
    } else {
      Slider?.classList.add('slide-none');
    }
    Slider?.classList.add('is-init')
  })

}

export default setMovieSlider;
